import { CustomerLookupQuery } from '@/features/pos/components/CustomerProfile/queries'
import {
    CustomerLookupCustomer,
    CustomerLookupQueryVariables,
} from '@/features/pos/components/CustomerProfile/types'
import { transformCustomerLookupCustomer } from '@/features/pos/components/CustomerProfile/utils/transforms'
import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

interface UseCustomerLookupCustomersArgs {
    variables?: CustomerLookupQueryVariables
}

export const useCustomerLookupCustomers = ({
    variables,
}: UseCustomerLookupCustomersArgs): CustomerLookupCustomer[] => {
    const { data } = useQuery(CustomerLookupQuery, {
        fetchPolicy: 'network-only',
        skip: !variables,
        variables,
    })

    return useMemo(
        () => data?.customers.map(transformCustomerLookupCustomer) ?? [],
        [data?.customers]
    )
}
